const pageDown = document.querySelectorAll(".page-down");
const headerHeight = document.querySelector("header").offsetHeight;

pageDown.forEach(btn => {
  
  btn.addEventListener("click", function () {
    const section = this.closest("section").nextElementSibling;
    if (!section) return;

    const top =
      section.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight;

    window.scrollTo({
      top: top,
      behavior: "smooth",
    });
  });

});
